import React from 'react';

const AudioContent = () => {
  return <div>AudioContent</div>;
};

export default AudioContent;
